/** @jsx isolateComponent */
import { css } from '@emotion/core';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';

type Props = {
  /**
   * The content to render within the component.
   */
  children: React.ReactNode;
  /**
   * Whether to show the node or hide it accessibly.
   * Generally this won't want to be shown but needs to
   * exist in the DOM for a11y purposes.
   */
  show?: boolean;
};

const Styles = labelStyles('TableCaption', {
  root: css`
    display: table-caption;
    &:not([data-show]) {
      position: absolute;
      height: 1px;
      width: 1px;
      overflow: hidden;
      clip: rect(1px, 1px, 1px, 1px);
    }
  `,
});

const defaultProps = {
  // Hidden by default since `TableTitleArea` will usually be used.
  // However for accessibility, it's necessary to render `table > caption`.
  show: false,
};

/**
 * The `caption` tag; use describe table data. Necessary for
 * accessibility, so always include it in your `Table`.
 */
export const TableCaption = (_props: Props) => {
  const props = {
    ...defaultProps,
    ..._props,
  };
  return (
    <caption css={Styles.root} data-show={props.show ? '' : undefined}>
      {props.children}
    </caption>
  );
};
